import { useState } from "react";
import LinkModal from "../components/LinkModal";
import LinksTable from "../components/LinksTable";

export default function LinksPage({ analytics, loading, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const links = analytics?.links || [];

  return (
    <div className="space-y-6">
      <section className="rounded-[32px] border border-white/10 bg-[rgba(11,18,31,0.92)] p-6 shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[var(--aff-muted)]">
              Links
            </div>
            <h2 className="mt-2 text-2xl font-black text-white">Create and track campaign links</h2>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-slate-300">
              Generate separate referral links for traffic sources, switch between turnover and revenue share programs, and copy them instantly for ads or partners.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="rounded-2xl bg-[var(--aff-accent)] px-5 py-3 text-sm font-bold text-slate-950 shadow-[0_18px_50px_rgba(29,217,175,0.28)] transition hover:brightness-105"
          >
            Create new link
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 md:grid-cols-3">
          <InfoCard label="Active links" value={loading ? "..." : String(links.length)} />
          <InfoCard
            label="Turnover links"
            value={
              loading
                ? "..."
                : String(
                    links.filter((link) =>
                      String(link.program || "").toLowerCase().includes("turnover")
                    ).length
                  )
            }
          />
          <InfoCard
            label="Revenue links"
            value={
              loading
                ? "..."
                : String(
                    links.filter((link) =>
                      String(link.program || "").toLowerCase().includes("revenue")
                    ).length
                  )
            }
          />
        </div>
      </section>

      <LinksTable links={links} loading={loading} />

      {showModal ? (
        <LinkModal
          onClose={() => setShowModal(false)}
          onSaved={() => {
            setShowModal(false);
            onRefresh?.();
          }}
        />
      ) : null}
    </div>
  );
}

function InfoCard({ label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3">
      <div className="text-xs uppercase tracking-[0.18em] text-[var(--aff-muted)]">{label}</div>
      <div className="mt-1 text-xl font-black text-white">{value}</div>
    </div>
  );
}
